<template>
    <el-dialog title="申领客户" :visible.sync="applyDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false"
        custom-class="custom-form-dialog custom_form_dialog custom-allocation-dialog custom-apply-dialog">
        <div class="custom_form_body">
            <el-form ref="formData" :rules="formRules" :model="formData" label-position="top" v-loading="formLoading">
                <el-form-item>
                    <template #label>
                        <span class="bold-text">您确认要申领下列选中的客户吗？</span>
                    </template>
                    <div class="select-company">
                        <p v-for="(companyItem, companyIndex) in selectedList" :key="companyItem.id">
                            {{ selectedList.length > 1 ? companyIndex + 1 + "." : ""
                            }}{{ companyItem.name && companyItem.name.value }}
                        </p>
                    </div>
                </el-form-item>
                <el-form-item>
                    <template #label>
                        <span class="bold-text">审批流程</span>
                    </template>
                    <approveProcessSelect ref="approveProcessSelectRef" :approval_node_list="approval_node_list"></approveProcessSelect>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { getApprovalNodes, CustomerClaim } from "@/api";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
export default {
    name: "CustomerApply",
    components: { approveProcessSelect },
    props: {
        applyDialog: {
            type: Boolean,
            default: false,
        },
        allocationCustomerId: {
            type: Number,
            default: 0,
        },
        selectedList: {
            type: Array,
            default: [],
        },
        sea_id: "",
    },
    data() {
        return {
            dialogVisible: false,
            formLoading: false,
            formData: {
                userId: "",
            },
            formRules: {},
            btnDisabled: false,
            nodeInfoList: [],

            approval_node_list: [],
        };
    },
    created() {
        this.getgetApprovalNodesData();
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:applyDialog", false);
        },
        getgetApprovalNodesData() {
            getApprovalNodes({ approval_type: "customer_claim" }).then((res) => {
                if (res.code === 200) {
                    this.approval_node_list = res.data;
                    this.$refs.approveProcessSelectRef.set_approval_node_list(res.data);
                }
            });
        },
        handleDialogConfirm() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    if (this.$refs.approveProcessSelectRef.handleClickPublish() == false) {
                        //审批节点校验没通过
                        return false;
                    }
                    this.btnDisabled = true;
                    this.formLoading = true;
                    const params = {
                        seas_id: this.sea_id,
                        customer_ids: this.selectedList.map((item) => item.id),
                        customers: this.selectedList.map((item)=> item.name.value),
                        node_list: this.approval_node_list,
                    };
                    CustomerClaim(params)
                        .then((res) => {
                            if (res.code === 200) {
                                this.$message.success(res.message);
                                this.$emit("update:applyDialog", false);
                                this.$emit("updateCallback");
                            }
                            this.btnDisabled = false;
                            this.formLoading = false;
                        })
                        .catch(() => {
                            this.btnDisabled = false;
                            this.formLoading = false;
                        });
                }
            });
        },
        receiveData(data) {
            if (data == false) {
                this.btnDisabled = true;
                this.formLoading = false;
                return false;
            }
            this.nodeInfoList = JSON.parse(JSON.stringify(data));
            this.formLoading = false;
        },
    },
};
</script>
<style lang="scss">
.custom-allocation-dialog {
    .bold-text {
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
    }

    .select-company {
        margin-top: 4px;
        padding: 8px 12px;
        border-radius: 6px;
        background: rgba(247, 248, 250, 1);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(51, 51, 51, 1);
        max-height: 236px;
        overflow-y: scroll;
    }
}

.custom-apply-dialog {
    .el-form {
        .el-form-item__content {
            height: auto;
            line-height: 22px;
        }
    }
}
</style>
